export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_URI = process.env.REACT_APP_BASE_URI;
export const TEMPLATE_URL=process.env.REACT_APP_UPLOAD_URL;
export const PUBLIC_URL = process.env.PUBLIC_URL;
